'use client';

import { QuoteSheetLineItems } from './quote-sheet-line-items';
import { EmailViewerV2 } from '@/components/email-viewer/email-viewer-v2';
import { useGetQuoteSheet } from '@/api/procurement/useGetQuoteSheet';
import { inboundEmailToEmailData } from '@/components/email-viewer/utils';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { useLocalStorageValue } from '@react-hookz/web';
import { Separator } from '@/components/ui/separator';
import { QuoteSheetMetadata } from './quote-sheet-metadata';

export function QuoteSheetDetails({ quoteSheetId }: { quoteSheetId: string }) {
  const { data, isLoading, refetch } = useGetQuoteSheet(quoteSheetId);
  const { value: panelSize, set: setPanelSize } = useLocalStorageValue<number>(
    'quote-sheet-details-panel-size',
    {
      defaultValue: 66,
      initializeWithValue: true,
    },
  );

  if (isLoading || !data) {
    return <div>Loading...</div>;
  }

  return (
    <ResizablePanelGroup direction="horizontal" className="gap-2 px-3">
      <ResizablePanel
        defaultSize={panelSize}
        onResize={(size) => setPanelSize(size)}
        minSize={25}
        className="flex flex-col space-y-2 h-full"
      >
        <QuoteSheetMetadata quoteSheet={data} />
        <Separator />
        <QuoteSheetLineItems items={data?.lineItems ?? []} quoteSheet={data} />
      </ResizablePanel>
      <ResizableHandle />

      <ResizablePanel minSize={20}>
        {data?.inboundEmail && (
          <EmailViewerV2
            emailData={inboundEmailToEmailData(data.inboundEmail)}
            defaultTab="attachments"
            onRefreshData={() => refetch()}
          />
        )}
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
